/**
 * Possible data types for Http Requests.
 */ export var DataTypes = /*#__PURE__*/ function(DataTypes) {
    DataTypes["Text"] = "text";
    DataTypes["Json"] = "json";
    return DataTypes;
}({});
/**
 * Http Request Type
 */ export var HttpMethods = /*#__PURE__*/ function(HttpMethods) {
    HttpMethods["Get"] = "GET";
    HttpMethods["Delete"] = "DELETE";
    HttpMethods["Patch"] = "PATCH";
    HttpMethods["Post"] = "POST";
    HttpMethods["Put"] = "PUT";
    return HttpMethods;
}({});
/**
 * Http Headers
 */ export var HttpHeaders = /*#__PURE__*/ function(HttpHeaders) {
    HttpHeaders["Accept"] = "Accept";
    HttpHeaders["Authorization"] = "Authorization";
    HttpHeaders["Bearer"] = "Bearer";
    HttpHeaders["ContentRange"] = "Content-Range";
    HttpHeaders["ContentType"] = "Content-Type";
    HttpHeaders["Date"] = "Date";
    HttpHeaders["IfMatch"] = "If-Match";
    HttpHeaders["Location"] = "Location";
    HttpHeaders["RetryAfter"] = "Retry-After";
    HttpHeaders["XSPSiteRootUrl"] = "X-SPSiteRootUrl";
    HttpHeaders["PreferHeader"] = "Prefer";
    HttpHeaders["ODataVersion"] = "OData-Version";
    return HttpHeaders;
}({});
/**
 * Http Headers Content Type
 */ export var HttpContentType = /*#__PURE__*/ function(HttpContentType) {
    HttpContentType["Json"] = "application/json";
    HttpContentType["TextPlain"] = "text/plain";
    HttpContentType["OctetStream"] = "application/octet-stream";
    return HttpContentType;
}({});
/**
 * Track Changes Header Value for delta queries
 */ export const TrackChangesHeaderValue = "odata.track-changes";
/**
 * Return Entity Header Value for create/update requests
 */ export const ReturnEntityHeaderValue = "return=representation";
/**
 * Include Unknown Enum Members Header Value for handling unknown enum values
 */ export const IncludeUnknownEnumMembersHeaderValue = "include-unknown-enum-members";
/**
 * The currently supported OData Version for Planner Service
 */ export const CurrentPlannerServiceODataVersion = "4.01";
